<template>
  <div v-if="isShowPage" class="page-box">
    <!-- PC端左侧导航栏 -->
    <div class="page-nav nav-pc" v-if="navList.length > 0 || true">
      <div class="create-btn" @click="createNew(null)">
        <div class="MO979HM2">新建对话</div>
      </div>
      <div class="nav-list">
        <div
          class="nav-item"
          v-for="item in navList"
          :key="item.id"
          :class="item.id == conversation_id ? 'active' : ''"
          @click="createNew(item.id)"
        >
          <div class="r1qZ7V8X">
            <span>
              {{ item.name }}
            </span>
            <span class="KtNWFhXf"
              ><span class="V4Z0LJMp" @click.stop="deleteHis(item.id)"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="currentColor"
                  class="JfRk4tcy"
                  viewBox="0 0 32 32"
                >
                  <g fill-rule="evenodd">
                    <path
                      d="M8.954 5.896H3.058A1.44 1.44 0 001.62 7.339a1.44 1.44 0 001.438 1.444h1.525l1.185 19.035a4.321 4.321 0 004.306 4.06h11.852a4.321 4.321 0 004.306-4.06l1.185-19.035h1.525a1.44 1.44 0 001.438-1.444 1.44 1.44 0 00-1.438-1.443h-2.865a1.3 1.3 0 00-.024 0h-3.007C22.38 2.602 19.48.122 16 .122s-6.38 2.48-7.046 5.774zm2.977 0h8.138A4.317 4.317 0 0016 3.009a4.317 4.317 0 00-4.069 2.887zm12.604 2.887H7.465l1.174 18.855a1.44 1.44 0 001.435 1.353h11.852a1.44 1.44 0 001.435-1.353l1.174-18.855zm-5.258 4.344c.793.056 1.39.746 1.334 1.54l-.601 8.64a1.44 1.44 0 01-1.535 1.34 1.442 1.442 0 01-1.334-1.541l.601-8.64a1.44 1.44 0 011.535-1.339zm-6.554 0a1.44 1.44 0 011.535 1.34l.602 8.64a1.442 1.442 0 01-1.335 1.54 1.44 1.44 0 01-1.535-1.34l-.601-8.64a1.442 1.442 0 011.334-1.54z"
                    ></path>
                    <path
                      fill-rule="nonzero"
                      d="M16 0c3.492 0 6.477 2.477 7.046 5.774h5.896c.86 0 1.558.7 1.558 1.565s-.698 1.566-1.558 1.566l-1.405-.114-1.185 19.034A4.442 4.442 0 0121.926 32H10.074a4.442 4.442 0 01-4.425-4.175L4.583 8.905H3.058c-.86 0-1.558-.7-1.558-1.566 0-.865.698-1.565 1.558-1.565l5.778.097C9.523 2.477 12.508 0 16 0zm0 .244c-3.378 0-6.265 2.396-7.046 5.774H3.058a1.32 1.32 0 00-.214 2.625l1.859.132L5.888 27.81a4.2 4.2 0 004.186 3.946h11.852a4.2 4.2 0 004.186-3.946l1.305-19.15h1.525a1.32 1.32 0 001.318-1.32c0-.73-.59-1.322-1.318-1.322l-6.013-.097A7.079 7.079 0 0016 .244zm8.535 8.417l.12.13-1.174 18.854a1.561 1.561 0 01-1.555 1.468H10.074a1.561 1.561 0 01-1.555-1.468L7.465 8.661h17.07zm-16.95.114L8.757 27.63a1.32 1.32 0 001.316 1.239h11.852a1.32 1.32 0 001.316-1.24l1.166-18.725-16.824-.129zm11.7 4.23l.229.033a1.565 1.565 0 011.217 1.638l-.602 8.64a1.56 1.56 0 01-1.662 1.452 1.563 1.563 0 01-1.446-1.67l.602-8.64a1.56 1.56 0 011.662-1.453zm-6.34.001a1.562 1.562 0 011.432 1.452l.602 8.64c.06.862-.588 1.61-1.445 1.67a1.56 1.56 0 01-1.663-1.452l-.602-8.64a1.563 1.563 0 011.446-1.67h.23zm6.324.243l-.215.002a1.32 1.32 0 00-1.192 1.224l-.602 8.64a1.32 1.32 0 102.63.184l.602-8.64a1.32 1.32 0 00-1.223-1.41zm-6.538 0l-.212.032a1.321 1.321 0 00-1.01 1.378l.601 8.64a1.32 1.32 0 102.63-.184l-.602-8.64a1.32 1.32 0 00-1.407-1.226zM16 2.887c1.894 0 3.56 1.203 4.069 3.131l-8.25-.163A4.437 4.437 0 0116 2.887zm0 .244c-1.792 0-3.369 1.138-4.069 2.643l8.025.163A4.197 4.197 0 0016 3.131z"
                    ></path>
                  </g></svg></span
            ></span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 移动端打开按钮 -->
    <div class="nav-mobile-bth">
      <i class="el-icon-s-unfold" @click="drawer = true"></i>
    </div>

    <div class="home-container">
      <div class="chat-body" ref="messageBody" id="messageBody">
        <div class="chat-list">
          <div
            v-for="(item, index) in messageBubble"
            :key="index"
            class="chat-item"
            :class="[item.role]"
            :style="
              item.type == 101
                ? 'display:flex;justify-content: center;align-items:center'
                : ''
            "
          >
            <img
              src="@/assets/images/kefu.png"
              alt="机器人头像"
              v-if="item.role == 'root'"
            />
            <img
              src="@/assets/images/user_blue.png"
              alt="用户头像"
              v-if="item.role == 'user'"
            />
            <div
              class="chat-bubble"
              :style="
                item.type == 4
                  ? 'width:75%'
                  : item.type == 101
                  ? 'width:100%;background:none;padding:0;'
                  : item.type == 10
                  ? 'background:#ddd;'
                  : ''
              "
            >
              <!-- 开头语 -->
              <template v-if="item.type == 100">
                <div class="start-box">
                  <div class="start-title">{{ startTitle }}</div>
                  <div style="margin-bottom: 20px">
                    {{ startContent }}
                  </div>
                  <div style="margin-bottom: 20px">你可以试着问我：</div>
                  <div class="start-list">
                    <div
                      class="start-item"
                      v-for="(item, index) in startList"
                      :key="index"
                      @click="send(item.content)"
                    >
                      <div>
                        <img
                          class="start-img"
                          :src="
                            require('@/assets/images/start' +
                              Number(Number(index) + 1) +
                              '_1.png')
                          "
                        />
                      </div>
                      <div>
                        <div class="start-item-title">{{ item.title }}</div>
                        <div class="start-item-content">
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else-if="item.type == 101">
                <div class="start-box1">------ 以上是历史对话 ------</div>
              </template>
              <!-- 问卷 -->
              <template v-else-if="item.type === 9">
                <div class="questionnaire">
                  <div class="naire-title">
                    你好，我是你的专属医美顾问小美，专注于眼部护理的智能顾问。
                  </div>
                  <el-form ref="form" :model="item.form" label-width="154px">
                    <el-form-item label="01 您的工作年限是？">
                      <el-select
                        v-model="item.form.workyear"
                        placeholder="请下拉选择工作年限"
                      >
                        <el-option label="0" value="0"></el-option>
                        <el-option label="1年" value="1"></el-option>
                        <el-option label="2年" value="2"></el-option>
                        <el-option label="3年" value="3"></el-option>
                        <el-option label="5年及以上" value="4"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="02 您的专业是？">
                      <el-cascader
                        v-model="item.form.major"
                        placeholder="请下拉选择对应专业"
                        :options="majorList"
                        :props="{
                          value: 'major',
                          label: 'major',
                          children: 'child_list',
                        }"
                        filterable
                        clearable
                      ></el-cascader>
                    </el-form-item>
                    <el-form-item label="03 您的学历是？">
                      <el-select
                        v-model="item.form.degree"
                        placeholder="请下拉选择最高学历"
                      >
                        <el-option label="专科" value="1"></el-option>
                        <el-option label="本科" value="2"></el-option>
                        <el-option label="硕士" value="3"></el-option>
                        <el-option label="博士" value="4"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="04 您的政治面貌是？">
                      <el-radio-group v-model="item.form.policy">
                        <el-radio label="中共党员/中共预备党员"></el-radio>
                        <el-radio label="共青团员"></el-radio>
                        <el-radio label="其他"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="05 意向报考地区是？">
                      <el-cascader
                        v-model="item.form.loc"
                        placeholder="请下拉选择对应地区"
                        :options="options"
                        clearable
                      ></el-cascader>
                    </el-form-item>
                    <el-form-item label="06 您的年龄是？">
                      <el-radio-group v-model="item.form.age">
                        <el-radio label="35岁以下"></el-radio>
                        <el-radio label="35岁以上"></el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item>
                      <el-button
                        type="primary"
                        @click="onSubmit(index)"
                        :disabled="item.form.isSubmit"
                        :loading="item.form.submitLoading"
                        >{{
                          item.form.isSubmit ? "已提交成功" : "确定"
                        }}</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </template>
              <!-- 表格 -->
              <template v-else-if="item.type === 4">
                <div>
                  <div
                    v-if="index == lastTableIndex && showScreen"
                    class="type-list"
                  >
                    筛选条件：
                    <el-checkbox-group v-model="checkList" @change="typeChange">
                      <el-checkbox
                        :label="item.type"
                        v-for="item in typeList"
                        :key="item.type"
                        >{{ item.name }}</el-checkbox
                      >
                    </el-checkbox-group>
                  </div>
                  <el-tabs
                    v-model="activeName"
                    type="card"
                    @tab-click="tabClick"
                    v-loading="tableLoading && index == lastTableIndex"
                    element-loading-spinner="el-icon-loading"
                    :element-loading-text="loadingText"
                    element-loading-custom-class="table-loading"
                  >
                    <el-tab-pane
                      v-if="item.message[0].length > 0"
                      label="国考"
                      name="country"
                    >
                      <lsf-table
                        tableType="gk"
                        :list="item.message[0]"
                      ></lsf-table>
                    </el-tab-pane>
                    <el-tab-pane
                      v-if="item.message[1].length > 0"
                      label="省考"
                      name="province"
                    >
                      <lsf-table
                        tableType="sk"
                        :list="item.message[1]"
                      ></lsf-table>
                    </el-tab-pane>
                  </el-tabs>
                  <div
                    v-if="
                      item.message[0].length === 0 &&
                      item.message[1].length === 0
                    "
                    class="no-data"
                  >
                    暂无数据
                  </div>
                  <div
                    v-if="
                      index == lastTableIndex &&
                      count[activeName] > 20 &&
                      showScreen
                    "
                    class="page-box"
                  >
                    <el-pagination
                      :page-size="20"
                      :pager-count="5"
                      layout="prev, pager, next"
                      :total="count[activeName]"
                      :current-page="currentPage"
                      @current-change="pageChange"
                    >
                    </el-pagination>
                  </div>
                </div>
              </template>
              <!-- 文本带“猜您想问” -->
              <template v-else-if="item.type === 5">
                <div class="other-box">
                  <div v-html="item.message"></div>
                  <div class="other-quesiton">
                    <span class="other-title">猜您想问：</span>
                    <div class="other-content" @click="send(item.question)">
                      {{ item.question }}
                    </div>
                  </div>
                </div>
              </template>
              <!-- 加载提示 -->
              <template v-else-if="item.type === 3">
                <div class="loading">
                  <span>
                    <!-- 请给我一些时间，我正在思考答案 -->
                    {{ item.message }}
                    <b></b>
                    <b></b>
                    <b></b>
                  </span>
                </div>
              </template>
              <!-- 停止响应的空文本 -->
              <template v-else-if="item.type === 7">
                <div></div>
              </template>
              <!-- 视频内容 -->
              <template v-else-if="item.type === 8">
                <a
                  href="javascript:void(0)"
                  @click="playVideo(item.message, item.time)"
                  >{{ item.message }}</a
                >
              </template>
              <!-- 置灰对话框 -->
              <template v-else-if="item.type === 10">
                <div class="">{{ item.message }}</div>
              </template>
              <!-- 纯文本 -->
              <template v-else-if="typeof item.message === 'string'">
                <div v-html="changeHref(item.message)"></div>
              </template>
              <div v-if="isShowRate(item, index)" class="rate-box">
                <img
                  v-if="item.active && item.active == 1"
                  class="zan"
                  @click="toEval(item, 0)"
                  src="@/assets/like/赞2.png"
                  alt=""
                />
                <img
                  v-if="!item.active"
                  class="zan"
                  @click="toEval(item, 1)"
                  src="@/assets/like/赞1.png"
                  alt=""
                />
                <img
                  v-if="item.active && item.active == -1"
                  @click="toEval(item, 0)"
                  class="cai"
                  src="@/assets/like/踩2.png"
                  alt=""
                />
                <img
                  v-if="!item.active"
                  class="cai"
                  @click="toEval(item, -1)"
                  src="@/assets/like/踩1.png"
                  alt=""
                />
                <div v-if="item.showFeedback" class="feedback-box">
                  <i class="el-icon-close" @click="hideFeedback(item)"></i>
                  <div class="feedback-title">您的反馈将帮助小禾优化进步</div>
                  <div class="feedback-list">
                    <!-- <div
                    class="feedback-item"
                    v-for="(tag, index) in tagList"
                    :key="index"
                    @click="chooseTag(item,tag)"
                  >
                    {{ tag }}
                  </div> -->
                    <el-checkbox-group v-model="item.feedbackTagList">
                      <el-checkbox-button
                        v-for="tag in tagList"
                        :label="tag"
                        :key="tag"
                        >{{ tag }}</el-checkbox-button
                      >
                    </el-checkbox-group>
                  </div>
                  <div class="feedback-input">
                    <el-input
                      v-model="item.feedbackComment"
                      placeholder="其他更多反馈"
                      prefix-icon="el-icon-edit"
                    ></el-input>
                  </div>
                  <div class="feedback-btn">
                    <el-button type="danger" @click="submitFeedback(item)"
                      >提交</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="!isInAnser && candidate && candidate.length > 0"
            class="chat-ass-mobile"
          >
            <div class="chat-ass-title">您可以继续问</div>
            <!-- <div class="ass-list"> -->
            <div
              class="ass-item"
              v-for="(item, index) in candidate"
              :key="index"
              @click="send(item)"
            >
              <div>{{ item }}</div>
            </div>
            <!-- </div> -->
            <div class="change-ass" @click="changeAss">换一换</div>
          </div>
        </div>
      </div>
      <div
        v-if="!isInAnser && candidate && candidate.length > 0"
        class="chat-ass"
      >
        <div>您可以继续问</div>
        <!-- <div class="ass-list"> -->
        <div
          class="ass-item"
          v-for="(item, index) in candidate"
          :key="index"
          @click="send(item)"
        >
          {{ item }}
        </div>
        <!-- </div> -->
        <div class="change-ass" @click="changeAss">换一换</div>
      </div>
      <div class="chat-message">
        <div class="send-content">
          <div
            contenteditable="true"
            class="edit-box"
            ref="edit"
            @keydown="textareaKeydown($event)"
          ></div>
          <div class="stop-request" v-if="isInAnser" @click="stopRequest">
            <div class="stop-icon"></div>
            <div class="stop-text">停止</div>
          </div>
          <svg
            v-else
            class="send-svg"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            @click="send()"
          >
            <path
              fill="#0ac66c"
              d="M12.8147 12.1969L5.28344 13.4521C5.10705 13.4815 4.95979 13.6029 4.89723 13.7704L2.29933 20.7278C2.05066 21.3673 2.72008 21.9773 3.33375 21.6705L21.3337 12.6705C21.8865 12.3941 21.8865 11.6052 21.3337 11.3288L3.33375 2.32885C2.72008 2.02201 2.05066 2.63206 2.29933 3.2715L4.89723 10.2289C4.95979 10.3964 5.10705 10.5178 5.28344 10.5472L12.8147 11.8024C12.9236 11.8205 12.9972 11.9236 12.9791 12.0325C12.965 12.1168 12.899 12.1829 12.8147 12.1969Z"
            ></path>
          </svg>
          <!-- <div class="send" @click="send()">
          <div v-if="isInAnser" class="loading">
            <span>
              <b></b>
              <b></b>
              <b></b>
            </span>
          </div>
          <span v-else>发送</span>
        </div> -->
        </div>
      </div>
      <loading :loading="Loading" />
      <el-dialog
        title="视频播放"
        :visible.sync="showVideo"
        custom-class="video-dialog"
        :key="Date.now()"
        @close="closeVideo"
      >
        <video ref="videoPlayer" class="video-js"></video>
      </el-dialog>
    </div>
    <el-drawer
      title=""
      :visible.sync="drawer"
      direction="ltr"
      :with-header="false"
    >
      <div class="page-nav nav-mobile">
        <div class="create-btn" @click="createNew(null)">
          <div class="MO979HM2">新建对话</div>
        </div>
        <div class="nav-list">
          <div
            class="nav-item"
            v-for="item in navList"
            :key="item.id"
            :class="item.id == conversation_id ? 'active' : ''"
            @click="createNew(item.id)"
          >
            <div class="r1qZ7V8X">
              <span>
                {{ item.name }}
              </span>
              <span class="KtNWFhXf"
                ><span class="V4Z0LJMp" @click.stop="deleteHis(item.id)"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="currentColor"
                    class="JfRk4tcy"
                    viewBox="0 0 32 32"
                  >
                    <g fill-rule="evenodd">
                      <path
                        d="M8.954 5.896H3.058A1.44 1.44 0 001.62 7.339a1.44 1.44 0 001.438 1.444h1.525l1.185 19.035a4.321 4.321 0 004.306 4.06h11.852a4.321 4.321 0 004.306-4.06l1.185-19.035h1.525a1.44 1.44 0 001.438-1.444 1.44 1.44 0 00-1.438-1.443h-2.865a1.3 1.3 0 00-.024 0h-3.007C22.38 2.602 19.48.122 16 .122s-6.38 2.48-7.046 5.774zm2.977 0h8.138A4.317 4.317 0 0016 3.009a4.317 4.317 0 00-4.069 2.887zm12.604 2.887H7.465l1.174 18.855a1.44 1.44 0 001.435 1.353h11.852a1.44 1.44 0 001.435-1.353l1.174-18.855zm-5.258 4.344c.793.056 1.39.746 1.334 1.54l-.601 8.64a1.44 1.44 0 01-1.535 1.34 1.442 1.442 0 01-1.334-1.541l.601-8.64a1.44 1.44 0 011.535-1.339zm-6.554 0a1.44 1.44 0 011.535 1.34l.602 8.64a1.442 1.442 0 01-1.335 1.54 1.44 1.44 0 01-1.535-1.34l-.601-8.64a1.442 1.442 0 011.334-1.54z"
                      ></path>
                      <path
                        fill-rule="nonzero"
                        d="M16 0c3.492 0 6.477 2.477 7.046 5.774h5.896c.86 0 1.558.7 1.558 1.565s-.698 1.566-1.558 1.566l-1.405-.114-1.185 19.034A4.442 4.442 0 0121.926 32H10.074a4.442 4.442 0 01-4.425-4.175L4.583 8.905H3.058c-.86 0-1.558-.7-1.558-1.566 0-.865.698-1.565 1.558-1.565l5.778.097C9.523 2.477 12.508 0 16 0zm0 .244c-3.378 0-6.265 2.396-7.046 5.774H3.058a1.32 1.32 0 00-.214 2.625l1.859.132L5.888 27.81a4.2 4.2 0 004.186 3.946h11.852a4.2 4.2 0 004.186-3.946l1.305-19.15h1.525a1.32 1.32 0 001.318-1.32c0-.73-.59-1.322-1.318-1.322l-6.013-.097A7.079 7.079 0 0016 .244zm8.535 8.417l.12.13-1.174 18.854a1.561 1.561 0 01-1.555 1.468H10.074a1.561 1.561 0 01-1.555-1.468L7.465 8.661h17.07zm-16.95.114L8.757 27.63a1.32 1.32 0 001.316 1.239h11.852a1.32 1.32 0 001.316-1.24l1.166-18.725-16.824-.129zm11.7 4.23l.229.033a1.565 1.565 0 011.217 1.638l-.602 8.64a1.56 1.56 0 01-1.662 1.452 1.563 1.563 0 01-1.446-1.67l.602-8.64a1.56 1.56 0 011.662-1.453zm-6.34.001a1.562 1.562 0 011.432 1.452l.602 8.64c.06.862-.588 1.61-1.445 1.67a1.56 1.56 0 01-1.663-1.452l-.602-8.64a1.563 1.563 0 011.446-1.67h.23zm6.324.243l-.215.002a1.32 1.32 0 00-1.192 1.224l-.602 8.64a1.32 1.32 0 102.63.184l.602-8.64a1.32 1.32 0 00-1.223-1.41zm-6.538 0l-.212.032a1.321 1.321 0 00-1.01 1.378l.601 8.64a1.32 1.32 0 102.63-.184l-.602-8.64a1.32 1.32 0 00-1.407-1.226zM16 2.887c1.894 0 3.56 1.203 4.069 3.131l-8.25-.163A4.437 4.437 0 0116 2.887zm0 .244c-1.792 0-3.369 1.138-4.069 2.643l8.025.163A4.197 4.197 0 0016 3.131z"
                      ></path>
                    </g></svg></span
              ></span>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <div class="pdf-btn" v-if="this.visitorId === 'portfolio_manager_1'">
      <el-upload
        class="upload-box"
        drag
        :action="URL_ENV.chatDevServerHost + '/pdf-parser'"
        :before-upload="beforeAvatarUpload"
        :on-success="handleSuccess"
        :on-error="handleError"
        :data="{
          uid: uid,
          sid: visitorId,
        }"
        :disabled="inUpload"
      >
        <div v-if="!inUpload" class="el-upload__text">PDF上传</div>
        <i v-if="inUpload" class="el-icon-loading"></i>
        <span v-if="inUpload" class="el-upload__text">上传中</span>
      </el-upload>
    </div>
    <div class="pdf-box"></div>
  </div>
  <div v-else class="page-info">{{ pageInfo }}</div>
</template>

<script>
import {
  preferredWx,
  getImgWx,
  newPreferredWx,
  preferredLsf2,
  positionSort,
  possiblyAsk,
  hisConverDev,
  profileDev,
  insert,
  pageHistory,
  addHis,
  delHis,
  createConversation,
  sendChatMessage,
  getConversations,
  getConversationDetail,
  deleteConversation,
} from "@/utils/api";
import Loading from "@/components/Loading";
import { MessageBox, Message } from "element-ui";
import LsfTable from "./components/lsftable.vue";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { URL_ENV, checkMixedContentIssues } from "@/utils/requestgpt";

import { changeHref } from "@/utils/index";
import $ from "jquery";

import videojs from "video.js";

import { options } from "./const";

let controller = "";
let signal = "";

export default {
  name: "chatRoot",
  components: {
    Loading,
    LsfTable,
  },
  data() {
    return {
      Loading: false,
      userMeasage: "",
      tempMessage: "",
      messageBubble: [
        // {
        //   role: "root",
        //   type: 101,
        //   message: "欢迎来到考公问答",
        // },
        {
          role: "root",
          type: 100,
          message: "",
        },
        // {
        //   role: "root",
        //   type: 9,
        //   message:
        //     "你好，我是华图小禾，您的智能问答助手，请在下方选择基本情况选项，我能更好解答您的问题",
        // },
      ],
      tips: ["小禾消息正在传输", "小禾的消息马上就到"],
      isInAnser: false,
      idTimer: null,
      conversation_id: null, // 使用新的API后，conversation_id由后端生成
      round: 0,
      visitorId: "",
      uid: "",
      typeList: [
        {
          name: "不限学位",
          type: "degree",
        },
        {
          name: "不限专业",
          type: "major",
        },
        {
          name: "不限政治面貌",
          type: "political_status",
        },
        {
          name: "不限工作经历",
          type: "work_year",
        },
      ],
      checkList: [],
      activeName: "country",
      currentPage: 1,
      count: {
        country: 0,
        province: 0,
      },
      tableLoading: false,
      loadingText: "",
      showScreen: true, //最后一项表格是否显示筛选等操作
      isForm: false,
      changeHref,
      isShowPage: false,
      pageInfo: "",
      startTitle: "你好，我是你的专属家政顾问小蜂",
      startContent:
        "作为你的家政服务专家顾问，我不仅能为你解答日常保洁、家电清洗、开荒保洁等常见问题，还能根据你的需求推荐适合的服务套餐、专业阿姨和清洁方案，甚至帮你预约上门服务。想知道我还能做什么？快点击下方对话框，和我聊聊吧！",
      startList: [
        {
          title: "服务咨询",
          icon: "",
          content: "精细保洁和专区保洁有什么不同？哪个更适合我家？",
        },
        {
          title: "家政知识",
          icon: "",
          content: "新房开荒需要做哪些项目？大概需要多长时间？",
        },
        {
          title: "套餐推荐",
          icon: "",
          content: "请推荐适合三居室的6小时家庭大扫除套餐",
        },
        // {
        //   title: "课程推荐",
        //   icon: "",
        //   content: "请推荐2024年国考行政能力测试课程",
        // },
      ],
      candidate: [],
      videoUrl: "",
      showVideo: false,
      player: null,
      videoOptions: {},

      pageStart: 0,
      pageSize: 10,
      hisNoMore: false,

      options,
      majorList: [],

      form: {
        workyear: "",
        major: [],
        age: "",
        policy: "",
        loc: [],
        degree: "",
      },
      isSubmit: false,
      submitLoading: false,
      lastTableIndex: 0,

      tagList: [
        "答非所问",
        "与上下文无关",
        "逻辑不合理",
        "无关内容太多",
        "重复提问",
        "与事实不符",
        "回答笼统不具体",
      ],
      drawer: false,
      navList: [],
      id: null,
      URL_ENV,
      inUpload: false,
    };
  },
  methods: {
    beforeAvatarUpload() {
      this.inUpload = true;
      console.log("开始上传");
    },
    handleSuccess(response, file, fileList) {
      this.inUpload = false;
      let str = file.response ? file.response.join("") : "";
      this.$alert("<div>" + str.replace(/\n/g, "<br/>") + "</div>", "预览", {
        dangerouslyUseHTMLString: true,
        customClass: "pdf-view",
      });
    },
    handleError(err, file, fileList) {
      this.inUpload = false;
      console.log("上传失败", err);
      this.$message.error("上传失败");
    },
    //监听按键操作
    textareaKeydown(event) {
      if (event.keyCode === 13) {
        //enter
        this.send();
        event.preventDefault(); // 阻止浏览器默认换行操作
        this.$refs.edit.blur();
        return false;
      }
    },
    chageConversationId() {
      this.showScreen = true;
      clearInterval(this.idTimer);
      // this.idTimer = setInterval(() => {
      //   this.conversation_id = Math.random().toString(16).slice(2);
      //   this.round = 0;
      //   this.showScreen = false;
      // }, 300000);
    },
    async send(paramsKey, noUser) {
      if (this.isInAnser) return;

      // 若是没有信息则不发送
      if (paramsKey) {
        this.userMeasage = paramsKey;
      } else {
        this.userMeasage = this.$refs.edit.innerHTML;
      }
      this.$refs.edit.innerHTML = "";
      if (!this.userMeasage || this.userMeasage.charCodeAt(0) === 10) {
        return;
      }
      this.checkList = [];

      // 如果没有conversation_id，先创建新对话
      if (!this.conversation_id) {
        try {
          const res = await createConversation({
            user_id: this.uid,
            tenant_id: 1
          });
          if (res && res.data && res.data.conversation_id) {
            this.conversation_id = res.data.conversation_id;
          } else {
            console.error("创建对话失败", res);
            this.$message.error("创建对话失败，请重试");
            return;
          }
        } catch (error) {
          console.error("创建对话异常", error);
          this.$message.error("创建对话失败，请重试");
          return;
        }
      }

      this.isInAnser = true;
      if (!noUser) {
        this.storeDataUpdate("user", this.userMeasage);
      }
      this.tempMessage = this.userMeasage;
      this.userMeasage = "";

      // 走问答接口
      // 展示加载问题
      this.storeDataUpdate("root", this.getTips(), 3);

      this.chageConversationId();

      this.isForm = false;
      this.fetchReq();
    },
    fetchReq() {
      let that = this;

      that.round += 1;
      that.$set(
        that.messageBubble[that.messageBubble.length - 1],
        "message",
        ""
      );

      // 使用新的API发送消息
      sendChatMessage({
        conversation_id: that.conversation_id,
        message: that.tempMessage,
        agent_id: 49,
        tenant_id: 1
      })
        .then((res) => {
          console.log("请求成功", res.data);
          let data = res.data;
        
          // 处理response内容，将换行符转换为HTML换行标签，并处理简单的Markdown格式
          let responseContent = data.agent_message || "";
          // 处理换行符
          responseContent = responseContent.replace(/\n/g, "<br>");
          // 处理Markdown粗体格式 **text** -> <strong>text</strong>
          responseContent = responseContent.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
          // 处理引用格式 > text -> <blockquote>text</blockquote>
          responseContent = responseContent.replace(/^>\s*(.*?)$/gm, "<blockquote>$1</blockquote>");
          
          that.changeBubble(
            that.messageBubble[that.messageBubble.length - 1],
            responseContent,
            0,
            0,
            that.round.toString()
          );

          // 请求完成后的处理
          that.isInAnser = false;
          that.$refs.edit.focus();
        })
        .catch((err) => {
          console.log("请求失败", err);
          that.isInAnser = false;
          that.$refs.edit.focus();
          // 移除加载提示
          that.messageBubble.pop();
        });
    },
    changeAss() {
      let that = this;
      possiblyAsk({
        uid: that.uid,
        sid: that.visitorId,
        question: that.tempMessage,
        round: that.round.toString(),
        switch: "1",
      }).then((res) => {
        that.candidate = res.data.candidate;
      });
    },
    stopRequest() {
      if (this.isForm) {
        this.tableLoading = false;
        signal.cancel("Operation canceled by the user.");
        this.isInAnser = false;
      } else {
        // 对于普通POST请求，只需要重置状态
        this.isInAnser = false;
        this.messageBubble.pop();
      }
    },

    storeDataUpdate(role, mesg, type) {
      let root = {
        role: role,
        message: mesg,
        type,
      };
      this.messageBubble.push(root);
      // 结束
      // this.Loading = false
      setTimeout(() => {
        this.messageBody.scrollTop = this.messageBody.scrollHeight;
      });
    },
    /**
     *
     * @param {*} type 0:字符串 3:加载提示 4:表格 5:猜你想问 6:流式请求返回的加载提示信息 7:停止响应之后的空对话 8:视频内容 9、问卷 10、置灰对话框  100、101:开头语
     * @param {*} time 视频类型的回答视频的开始播放时间
     * @param {*} isRate 是否赞过踩过
     */

    changeBubble(item, message, type = 0, isRate, round, question, time, form) {
      this.$set(item, "message", message);
      this.$set(item, "type", type);
      this.$set(item, "active", isRate);
      this.$set(item, "round", round);
      this.$set(item, "question", question);
      this.$set(item, "time", time);
      this.$set(item, "form", form);
      // 保存气泡的长度
      this.$set(item, "length", (message && message.length) || 0);

      this.$set(item, "showFeedback", false);
      this.$set(item, "feedbackTagList", []);
      this.$set(item, "feedbackComment", "");
      this.dataType = type;
      setTimeout(() => {
        this.messageBody.scrollTop = this.messageBody.scrollHeight;
      });
    },
    getTips() {
      let tip = this.tips[Math.floor(Math.random() * this.tips.length)];
      return tip;
    },
    typeChange() {
      this.currentPage = 1;
      this.count = {
        country: 0,
        province: 0,
      };
      this.handleReq();
    },
    handleReq(type) {
      this.tableLoading = true;
      this.isInAnser = true;
      this.chageConversationId();
      controller = this.axios.CancelToken;
      signal = controller.source();
      this.isForm = true;
      this.axios
        .post(
          URL_ENV.chatDevServerHost + "/PositionSort",
          {
            uid: this.uid,
            sid: this.visitorId,
            conversation_id: this.conversation_id.toString(),
            unlimited: this.checkList,
            page: this.currentPage,
          },
          {
            timeout: 0, // 设置超时时间为 0/null 表示永不超时
            cancelToken: signal.token, // 绑定取消请求的信号量
          }
        )
        .then((res) => {
          this.isInAnser = false;
          this.tableLoading = false;
          this.count = {
            country: res.data.data.count[0],
            province: res.data.data.count[1],
          };
          this.changeBubble(
            this.messageBubble[this.lastTableIndex],
            res.data.data.jobList,
            4,
            0,
            this.round.toString()
          );
          // if (type == "add") {
          // this.addHis(this.tempMessage, res.data.data.jobList, "JOB");
          // }
        })
        .catch((error) => {
          this.isInAnser = false;
          this.tableLoading = false;
        });
      // positionSort({
      //   user_id: this.visitorId,
      //   conversation_id: this.conversation_id.toString(),
      //   unlimited: this.checkList,
      //   page: this.currentPage,
      // })
      //   .then((res) => {
      //     this.isInAnser = false;
      //     this.tableLoading = false;
      //     this.count = {
      //       country: res.data.data.count[0],
      //       province: res.data.data.count[1],
      //     };
      //     this.changeBubble(
      //       this.messageBubble[this.messageBubble.length - 1],
      //       res.data.data.jobList,
      //       4,
      //       0,
      //       this.round.toString()
      //     );
      //   })
      //   .catch((error) => {
      //     this.isInAnser = false;
      //     this.tableLoading = false;
      //   });
    },
    pageChange(val) {
      this.currentPage = val;
      this.count = {
        country: 0,
        province: 0,
      };
      this.handleReq();
    },
    tabClick() {
      this.currentPage = 1;
    },
    isShowRate(item, index) {
      if (item.type === 100 || item.type === 101 || item.type == 9)
        return false;
      if (item.role == "user") return false;
      if (index == this.messageBubble.length - 1) {
        if (this.isInAnser) return false;
        if (item.type === 7) return false;
        return true;
      } else {
        if (
          item.type === 0 ||
          item.type == 4 ||
          item.type == 5 ||
          item.type == 8
        )
          return true;
        return false;
      }
    },
    /**
     *
     * @param {* 0：取消 1:赞 -1:踩} rate
     */
    toEval(item, rate, tag, comment) {
      if (rate == -1) {
        this.$set(item, "showFeedback", true);
        return;
      }
      this.$set(item, "active", rate);
      feedback({
        uid: this.uid,
        sid: this.visitorId,
        // conversation_id: this.conversation_id.toString(),
        round: item.round.toString(),
        emotion: rate,
        tag: [],
        comment: "",
      }).then((res) => {});
    },
    hideFeedback(item) {
      this.$set(item, "showFeedback", false);
    },
    submitFeedback(item) {
      this.$set(item, "active", -1);
      this.$set(item, "showFeedback", false);
    },
    playVideo(url, time = 0) {
      this.videoOptions = {
        autoplay: true,
        controls: true,
        preload: "auto",
        sources: [
          {
            src: url,
          },
        ],
      };

      this.videoUrl = url;
      this.showVideo = true;
      setTimeout(() => {
        this.player = videojs(
          this.$refs.videoPlayer,
          this.videoOptions
          // function onPlayerReady() {
          //   console.log("onPlayerReady", this);
          // }
        );
        this.player.currentTime(time);
      });
    },
    closeVideo() {
      if (this.player) {
        // this.player.pause();
        this.player.dispose();
        this.player = null;
      }
    },

    getHisConver(start) {
      hisConverDev({
        // uid: "74ae2dce36f63661e3c62b9796503409",
        uid: this.uid,
        pageStart: this.pageStart,
        pageSize: this.pageSize,
      }).then((res) => {
        this.getMajorList();
        let arr = [];
        if (res.data.conversationList.length < this.pageSize) {
          this.hisNoMore = true;
        }
        res.data.conversationList.forEach((data) => {
          let type = 0;
          if (data.type == "JOB") {
            type = 4;
          } else if (data.type == "VIDEO") {
            type = 8;
          }
          arr.push({
            role: "user",
            message: data.question,
            type: 0,
          });
          arr.push({
            role: "root",
            message: data.answer,
            type,
            active: 0,
            round: "",
            question: "",
            time: data.start_time,
          });
        });
        this.messageBubble = arr.concat(this.messageBubble);
        if (start) {
          setTimeout(() => {
            this.messageBody.scrollTop = this.messageBody.scrollHeight;
          });
        } else {
          this.messageBody.scrollTop = 100;
        }
      });
    },
    async getPossiblyAsk() {
      // this.getHisConver(1);

      possiblyAsk({
        uid: this.uid,
        sid: this.visitorId,
        question: this.tempMessage,
        round: this.round.toString(),
        switch: "0",
      }).then((res) => {
        res.data.candidate.forEach((item, index) => {
          this.startList[index].content = item;
        });
      });
    },
    onSubmit(index) {
      if (this.messageBubble[index].form.workyear === "") {
        return Message({
          message: "请选择工作年限",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (this.messageBubble[index].form.major.length == 0) {
        return Message({
          message: "请选择对应专业",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.degree) {
        return Message({
          message: "请选择最高学历",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.policy) {
        return Message({
          message: "请选择政治面貌",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (this.messageBubble[index].form.loc.length == 0) {
        return Message({
          message: "请选择对应地区",
          type: "warning",
          duration: 3 * 1000,
        });
      } else if (!this.messageBubble[index].form.age) {
        return Message({
          message: "请选择您的年龄",
          type: "warning",
          duration: 3 * 1000,
        });
      }
      this.messageBubble[index].form.submitLoading = true;
      let form = { ...this.messageBubble[index].form };
      form.major =
        this.messageBubble[index].form.major[0] +
        "/" +
        this.messageBubble[index].form.major[1];
      let loc = [];
      loc.push(
        this.messageBubble[index].form.loc[
          this.messageBubble[index].form.loc.length - 1
        ]
      );
      form.loc = loc;
      form.uid = this.uid;
      form.sid = this.visitorId;
      profileDev(form)
        .then((res) => {
          this.messageBubble[index].form.submitLoading = false;
          this.send("问卷填写好了", true);
          if (res.data.code == 200) {
            this.messageBubble[index].form.isSubmit = true;
          }
        })
        .catch(() => {
          this.messageBubble[index].form.submitLoading = false;
        });
    },
    getMajorList() {
      // 移除list-major接口调用，使用空数据
      console.log('已移除list-major接口调用');
      this.majorList = [];
    },

    async createNew(id) {
      this.drawer = false;
      this.candidate = [];
      if (id) {
        // 切换到历史对话
        this.id = id;
        this.conversation_id = id; // 设置当前对话ID
        this.pageStart = 0;
        this.pageSize = 10;
        this.messageBubble = [];
        this.hisNoMore = false;
        this.getHis(true);
        this.isInAnser = false;
        return;
      }
      // 创建新对话
      if (this.messageBubble.length == 1 && !this.conversation_id) {
        return Message({
          message: "当前已是新对话",
          type: "warning",
          duration: 3 * 1000,
        });
      }
      try {
        // 调用API创建新对话
        const res = await createConversation({
          user_id: this.uid,
          tenant_id: 1
        });
        if (res && res.data && res.data.conversation_id) {
          this.conversation_id = res.data.conversation_id;
          this.id = null;
          this.messageBubble = [
            {
              role: "root",
              type: 100,
              message: "",
            },
          ];
          // 刷新对话列表
          this.getHisList();
        } else {
          this.$message.error("创建新对话失败");
        }
      } catch (error) {
        console.error("创建新对话异常", error);
        this.$message.error("创建新对话失败，请重试");
      }
    },
    async getHis(start) {
      if (!this.conversation_id) {
        // 如果没有conversation_id，显示开头语
        if (start) {
          this.messageBubble = [
            {
              role: "root",
              type: 100,
              message: "",
            },
          ];
          setTimeout(() => {
            if (this.messageBody) {
              this.messageBody.scrollTop = this.messageBody.scrollHeight;
            }
          });
        }
        return;
      }
      try {
        const res = await getConversationDetail(this.conversation_id, {
          tenant_id: 1
        });
        if (res && res.data && res.data.messages) {
          let arr = [];
          const messages = res.data.messages;
          
          // 标记没有更多数据（因为新API不支持分页）
          this.hisNoMore = true;
          
          // 转换消息格式
          messages.forEach((msg) => {
            if (msg.role === "user") {
              arr.push({
                role: "user",
                message: msg.content,
                type: 0,
              });
            } else if (msg.role === "assistant") {
              // 根据内容判断类型（这里可以根据实际需求调整）
              let type = 0;
              arr.push({
                role: "root",
                message: msg.content,
                type,
                active: 0,
                round: "",
                question: "",
                time: msg.timestamp,
              });
            }
          });
          
          // 如果是首次加载，替换所有消息；否则追加到顶部
          if (start) {
            // 如果有历史消息，不显示开头语；如果没有，显示开头语
            if (arr.length > 0) {
              this.messageBubble = arr;
            } else {
              this.messageBubble = [
                {
                  role: "root",
                  type: 100,
                  message: "",
                },
              ];
            }
          } else {
            this.messageBubble = arr.concat(this.messageBubble);
          }
          
          // 滚动到底部或顶部
          if (start) {
            setTimeout(() => {
              if (this.messageBody) {
                this.messageBody.scrollTop = this.messageBody.scrollHeight;
              }
            });
          } else {
            if (this.messageBody) {
              this.messageBody.scrollTop = 100;
            }
          }
        } else {
          // 如果没有消息，显示开头语
          if (start) {
            this.messageBubble = [
              {
                role: "root",
                type: 100,
                message: "",
              },
            ];
            setTimeout(() => {
              if (this.messageBody) {
                this.messageBody.scrollTop = this.messageBody.scrollHeight;
              }
            });
          }
        }
      } catch (error) {
        console.error("获取对话详情失败", error);
        this.$message.error("获取对话详情失败");
        // 出错时显示开头语
        if (start) {
          this.messageBubble = [
            {
              role: "root",
              type: 100,
              message: "",
            },
          ];
        }
      }
    },
    addHis(question, answer, answer_type) {
      // 旧的API方法，新API不需要手动保存历史记录
      // 历史记录由后端自动管理
      addHis({
        sid: this.visitorId,
        uid: this.uid,
        question: question,
        answer: answer,
        answer_type: answer_type,
        round: this.round.toString(),
        conv_id: this.id,
      });
    },
    async deleteHis(id) {
      this.$confirm("此操作将永久删除该对话, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          await deleteConversation(id, {
            agent_id: 49,
            tenant_id: 1
          });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getHisList();
          if (id == this.id || id == this.conversation_id) {
            this.createNew(null);
          }
        } catch (error) {
          console.error("删除对话失败", error);
          this.$message.error("删除对话失败");
        }
      });
    },
    async getHisList(callback) {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      this.uid = result.visitorId;
      
      try {
        // 调用新的API获取对话列表
        const res = await getConversations({
          user_id: this.uid,
          tenant_id: 1
        });
        if (res && res.data) {
          // 转换数据格式以适配现有UI
          this.navList = res.data.map((item) => ({
            id: item.id,
            name: item.title || "新对话",
            created_at: item.created_at,
            updated_at: item.updated_at,
            message_count: item.message_count
          }));
        } else {
          this.navList = [];
        }
      } catch (error) {
        console.error("获取对话列表失败", error);
        this.navList = [];
      }
      
      if (callback) {
        callback();
      }
    },
    getIntroduce() {
      // 移除func-introduce接口调用，使用默认数据
      console.log('已移除func-introduce接口调用');
    },
  },
  created() {
    document.title = "AI客服";
    let sid =
      this.$route.query.sid === undefined
        ? this.$route.query.uid
        : this.$route.query.sid;
    this.visitorId = sid;
    
      // 检查混合内容问题
      checkMixedContentIssues();
      
      // 直接进入系统，跳过 verify-saler 接口调用
      this.isShowPage = true;
      this.$forceUpdate();
      // 初始化时获取对话列表
      this.getHisList(() => {
        // 如果有对话列表，可以选择加载最新的对话
        // 或者保持空白状态，等待用户发送第一条消息
        this.getIntroduce();
      });
    setTimeout(() => {
      this.messageBody = this.$refs.messageBody;
      const dom = document.getElementById("messageBody");
      this.getMajorList();
      dom.addEventListener("scroll", () => {
        // 由于新API不支持分页加载，暂时禁用滚动加载更多历史记录
        // 如果需要，可以在API中实现分页功能后再启用
        // const clientHeight = dom.clientHeight;
        // const scrollTop = dom.scrollTop;
        // const scrollHeight = dom.scrollHeight;
        // if (scrollTop == 0 && !this.hisNoMore) {
        //   if (this.messageBubble.length >= this.pageSize) {
        //     this.pageStart++;
        //     this.getHis();
        //   }
        // }
      });
    });
  },
  destoryed() {
    const dom = document.getElementById("messageBody");
    dom.removeEventListener("scroll", () => {});
  },
  async mounted() {
    // this.timer = setInterval(() => {
    //   this.date = new Date();
    // }, 1000);
    // this.userId = Math.floor(Math.random() * 10000);
    // 关闭定时器 不自动刷新conversation_id
    // this.idTimer = setInterval(() => {
    //   this.conversation_id++;
    // }, 300000);
  },

  beforeRouteLeave(to, from, next) {
    from.meta.scrollTop = this.messageBody.scrollTop;
    from.meta.scrollEl = this.messageBody;
    next();
  },
  directives: {
    LongPress: {
      inserted(el, binding, vnode) {
        let timer = null;

        function touchStart(e) {
          clearTimeout(timer);
          timer = setTimeout(function () {
            let touches = e.touches[0];
            let context = vnode.context;
            let community = context.$refs.community;
          }, 300);
        }

        function touchMove(e) {
          clearTimeout(timer);
          e.preventDefault();
        }

        function touchEnd() {
          clearTimeout(timer);
        }

        el._touchStart = touchStart;
        el._touchMove = touchMove;
        el._touchEnd = touchEnd;
        el.addEventListener("touchstart", el._touchStart);
        el.addEventListener("touchmove", el._touchMove);
        el.addEventListener("touchend", el._touchEnd);
      },
      unbind(el, binding, vnode) {
        el.removeEventListener("touchstart", el._touchStart);
        el.removeEventListener("touchmove", el._touchMove);
        el.removeEventListener("touchend", el._touchEnd);
        delete el._touchStart;
        delete el._touchMove;
        delete el._touchEnd;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  display: flex;
  width: 100%;
  position: relative;
  
  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
  
  .page-nav {
    width: 15%;
    padding: 30px 0;
    box-sizing: border-box;
    
    @media screen and (max-width: 900px) {
      width: 100%;
      padding: 20px 0;
    }
    background: radial-gradient(
        circle at 100% 0,
        #efe8eb 0,
        rgba(239, 232, 235, 0) 33%
      ),
      radial-gradient(circle at 100% 25%, #e8ebea 0, hsla(160, 7%, 92%, 0) 39%),
      radial-gradient(
        circle at 100% 36%,
        hsla(160, 7%, 92%, 0.6) 0,
        hsla(160, 7%, 92%, 0) 38%
      ),
      linear-gradient(180deg, #efeaef, #dcdcf5 99%);
    .create-btn {
      background: linear-gradient(139deg, #d8f, #1b44e2);
      border-radius: 7px;
      color: #4955f5;
      cursor: pointer;
      display: flex;
      height: 40px;
      justify-content: center;
      margin-left: 20px;
      overflow: hidden;
      padding: 1px;
      width: 122px;
      align-items: center;
      margin-bottom: 30px;
      
      @media screen and (max-width: 900px) {
        width: calc(100% - 40px);
        margin: 0 20px 20px 20px;
        height: 44px;
      }
      .MO979HM2 {
        align-items: center;
        background: #efebef;
        border-radius: 6px;
        color: #4955f5;
        display: flex;
        font-size: 16px;
        height: 100%;
        justify-content: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        width: 100%;
      }
    }
    .nav-list {
      .nav-item {
        padding: 0 10px;
        // line-height: 50px;
        // border-radius: 6px;
        // padding: 0 20px;
        // cursor: pointer;
        // font-size: 14px;
        // color: #000c3f;
        .r1qZ7V8X {
          align-items: center;
          color: #000c3f;
          cursor: pointer;
          display: flex;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          font-weight: 400;
          height: 50px;
          letter-spacing: 0;
          line-height: 50px;
          overflow: hidden;
          padding: 0 20px 0 8px;
          position: relative;
          text-align: justify;
          text-overflow: ellipsis;
          white-space: nowrap;
          .KtNWFhXf {
            align-items: center;
            background-image: linear-gradient(
              90deg,
              hsla(0, 0%, 100%, 0),
              #fff 12%
            );
            display: flex;
            height: 50px;
            justify-content: flex-end;
            opacity: 0;
            position: absolute;
            right: 0;
            top: 0;
            width: 108px;
            .V4Z0LJMp {
              align-items: center;
              color: #7886a4;
              display: flex;
              height: 20px;
              justify-content: center;
              margin-right: 4px;
              width: 20px;
              .JfRk4tcy {
                color: #7886a4;
                height: 13px;
                width: 13px;
              }
            }
            .V4Z0LJMp:hover {
              background: #e1e5fa;
              border-radius: 4px;
            }
          }
        }
        .r1qZ7V8X:hover {
          background: hsla(0, 0%, 100%, 0.9);
          border-radius: 8px;
          box-shadow: 0 16px 20px 0 rgba(174, 167, 223, 0.06);
          .KtNWFhXf {
            opacity: 1;
          }
        }
      }
      .nav-item.active {
        .r1qZ7V8X {
          background: hsla(0, 0%, 100%, 0.9);
          border-radius: 8px;
          box-shadow: 0 16px 20px 0 rgba(174, 167, 223, 0.06);
          .KtNWFhXf {
            // opacity: 1;
          }
        }
      }
      // .nav-item:hover {
      //   background: #fff;
      // }
    }
  }
  .nav-mobile-bth {
    display: none;
    padding: 20px 0 20px 20px;
    .el-icon-s-unfold {
      font-size: 26px;
      color: #145dff;
      cursor: pointer;
    }
  }
  @media screen and (max-width: 900px) {
    .nav-pc {
      display: none;
    }
    .nav-mobile {
      width: 100%;
      height: 100%;
    }
    .page-nav {
      width: 100% !important;
    }
  }
  
  .nav-mobile-bth {
    display: none;
    
    @media screen and (max-width: 900px) {
      display: flex;
      padding: 15px 0 15px 15px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      background: transparent;
      width: 50px;
      height: 50px;
      align-items: center;
      justify-content: center;
      border-radius: 0 0 8px 0;
      
      .el-icon-s-unfold {
        font-size: 24px;
        color: #145dff;
        cursor: pointer;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
        
        &:active {
          transform: scale(0.95);
          background: rgba(255, 255, 255, 0.95);
        }
      }
    }
  }
  
  .nav-pc {
    display: block;
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    overflow-y: auto;
    
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
}
.home-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
  max-width: 900px;
  margin: 0 auto 10px auto;
  margin-left: 15%; /* PC端为左侧导航栏留出空间 */
  
  @media screen and (max-width: 900px) {
    margin-left: 0; /* 移动端不需要左边距 */
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
}

.chat-header {
  /* 聊天机器人头部信息 */
  width: 100%;
  box-sizing: border-box;
  box-shadow: 0 6px 12px rgba(39, 165, 251, 0.25);
  font-size: 0;
}

.chat-header img {
  width: 100%;
}

.chat-header .logo {
  flex: 0 2 auto;
  width: 142px;
}

.chat-header .logo img {
  width: 100%;
  height: 100%;
}

.chat-header .des {
  /* font-size: 15px; */
}

.chat-header .des .vertial::after {
  content: "|";
  margin-left: 2px;
}

.chat-body {
  width: 100%;
  padding-top: 30px;
  height: calc(94vh - 57px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  /*有回弹效果*/
  /* border-bottom: 1px solid #bbb; */
  // background: #f6f8fa;
  
  @media screen and (max-width: 900px) {
    padding-top: 60px; /* 为移动端顶部按钮留出空间 */
    height: calc(100vh - 60px);
    padding-bottom: 80px; /* 为底部输入框留出空间 */
  }
}

.chat-message {
  position: relative;
  width: 100%;
  /*min-height: 6vh;*/
  box-sizing: border-box;
  line-height: 6vh;
  display: flex;
  align-items: center;
  // flex-direction: column;
  padding: 14px 14px 14px 22px;
  // background: #cce8fc;
  // background: #fff;
  
  @media screen and (max-width: 900px) {
    padding: 10px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
    border-top: 1px solid #eee;
  }
  
  .select-box {
    display: flex;
    align-items: center;
    margin-left: 14px;
    .el-icon-circle-plus-outline {
      font-size: 34px;
      color: #5ac275;
    }
  }
}

.chat-message .send-content {
  display: flex;
  align-items: center;
  background: #f6f8fa;
  // border: 1px solid #ccc;
  border-radius: 24px;
  padding: 0 10px;
  flex: 1;
  .send-svg {
    width: 24px;
    color: #1b4aef;
    cursor: pointer;
  }

  .stop-request {
    position: initial;
    line-height: 1;
    border: none;
    background: none;
    // padding: 0;
    transform: none;
    .stop-icon {
      // background: #0ac66c;
      background: #cc3026;
    }
  }
}

.chat-message .edit-box {
  flex: 1;
  font-size: 14px;
  outline: none;
  // background: #f6f8fa;
  padding: 11px 10px;
  box-sizing: border-box;
  max-height: 88px;
  margin-right: 10px;
  overflow: hidden;
  border-radius: 6px;
  user-modify: read-write-plaintext-only;
  -webkit-user-modify: read-write-plaintext-only;
  overflow-y: scroll;
  line-height: 22px;
  // border: 1px solid #ccc;
  box-sizing: border-box;
  
  @media screen and (max-width: 900px) {
    font-size: 14px;
    padding: 8px 10px;
    max-height: 60px;
    margin-right: 8px;
    line-height: 20px;
  }
}

.chat-message .edit-box:empty:before {
  content: "请输入您的问题";

  color: gray;
}

.chat-message .edit-box:focus:before {
  content: none;
}

.send {
  width: 60px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  background: #145dff;
  font-size: 14px;
  color: #feffff;
  font-family: PingFangSC-Regular;
  cursor: pointer;
}

.community {
  position: absolute;
  right: 2px;
  bottom: 60px;
  font-size: 12px;
  color: #fff;
  display: inline-block;
  width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 50%;
  text-align: center;
  background: rgba(45, 140, 240, 0.7);
}

.chat-list {
  -webkit-overflow-scrolling: touch;
  padding-top: 10px;
  padding-bottom: 20px;
}

.chat-item {
  display: inline-flex;
  align-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px 0 16px;
  margin-bottom: 30px;
  
  @media screen and (max-width: 900px) {
    padding: 0 10px;
    margin-bottom: 20px;
  }
  .rate-box {
    position: relative;
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    height: 20px;
    img {
      width: 20px;
      height: auto;
      cursor: pointer;
    }
    .cai {
      width: 17px;
      margin-left: 10px;
    }
    .feedback-box {
      position: absolute;
      bottom: 100%;
      right: 0;
      padding: 10px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 6px 12px rgba(39, 165, 251, 0.25);
      .el-icon-close {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        font-size: 18px;
      }
      .feedback-title {
        margin-bottom: 10px;
        font-weight: 700;
        font-size: 18px;
      }
      .feedback-list {
        display: flex;
        max-width: 400px;
        flex-wrap: wrap;
        .feedback-item {
          padding: 4px 10px;
          background: #f4f6f7;
          border-radius: 6px;
          margin: 0 10px 10px 0;
          cursor: pointer;
        }
      }
      .feedback-input {
        margin-bottom: 10px;
      }
      .feedback-btn {
        text-align: center;
      }
    }
  }
}

.chat-item img:not(.cai):not(.zan):not(.img-message):not(.start-img) {
  width: 34px;
  height: 34px;
  vertical-align: top;
  background: none;
  border-radius: 6px;

  // padding: 5px;
  // box-sizing: border-box;
  // box-shadow: 0 6px 12px rgba(39, 165, 251, 0.25);
  background: #1b4aef;
  
  @media screen and (max-width: 900px) {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }
}
.img-message {
  max-width: 500px;
  max-height: 500px;
}
.user img {
  // background: #0ac66c !important;
  background: none !important;
}

.chat-bubble {
  position: relative;
  display: inline-block;
  border: none;
  border-radius: 0px;
  padding: 2px 8px;
  max-width: 75%;
  line-height: 22px;
  word-wrap: break-word;
  border-radius: 12px;
  word-break: break-all;
  letter-spacing: 0.01rem;
  font-size: 14px;
  vertical-align: middle;
  
  @media screen and (max-width: 900px) {
    max-width: 85%;
    font-size: 14px;
    line-height: 20px;
    padding: 8px 12px;
  }
}

.chat-bubble .recomand-list {
  display: flex;
}

.chat-bubble .recomand-list div {
  width: 120px;
  height: 120px;
  background: red;
  margin-right: 5px;
}

.chat-bubble .qa-tip {
  font-size: 16px;
  margin: 0;
  font-weight: 500;
  margin-bottom: 0;
}

.chat-bubble .qa-list {
  cursor: pointer;
  color: #2d8cf0;
  user-select: none;
}

.chat-bubble .qa-list :active {
  color: #145dff;
}

.chat-bubble ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.chat-bubble .qa-tip {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0;
}

.chat-bubble .qa-list {
  cursor: pointer;
  color: #2d8cf0;
  user-select: none;
}

.chat-bubble .qa-list :active {
  color: #145dff;
}

.chat-bubble ul {
  margin: 0;
  padding: 0;
}

/* 这便是机器人 */
.root {
  align-items: flex-start;
}

.root .chat-bubble {
  background: #fff;
  color: #333;
  margin-left: 10px;
  padding: 14px;
  
  @media screen and (max-width: 900px) {
    margin-left: 8px;
    padding: 10px 12px;
  }
}

.chat-bubble::before {
  /* 三角形 */
  // position: absolute;
  // content: "";
  // height: 0;
  // width: 0;
  // border: 7px solid transparent;
}

.root .chat-bubble::before {
  border-right-color: #fff;
  /* border-right-color: rgb(141, 250, 105); */
  left: -13px;
}

/* 这边是用户 */
.user {
  display: inline-flex;
  // justify-content: flex-end;
  align-items: flex-start;
}

.user .chat-bubble {
  color: #fff;
  // background: #0ac66c;
  // background: linear-gradient(130deg, #2870ea 20%, #1b4aef 77.5%);
  // margin-right: 10px;
  margin-left: 10px;
  padding: 6px 10px;
  color: #333;
  
  @media screen and (max-width: 900px) {
    margin-left: 8px;
    padding: 8px 12px;
  }
}

.user .chat-bubble::before {
  /* border-left-color: #60ba99; */
  border-left-color: #0ac66c;
  right: -12px;
}

/*各种分类展示 样式表*/
.ppt,
.book {
  padding: 10px;
  height: 100%;
  /*display: flex;*/
  flex-direction: column;
  font-size: 12px;
}
.ppt,
.book .des {
  border-top: 1px solid #ccc;
  margin: 10px 0;
}

.ppt .ppt-cover,
.book .book-cover {
  flex: 0 0 80%;
  overflow: hidden;
}

.des {
  text-overflow: ellipsis;
  /*overflow: hidden;*/
  /*white-space: nowrap;*/
}

.news {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-left {
  flex: 0 0 20%;
  width: 20%;
  box-sizing: border-box;
  padding: 5px 0;
  height: 100%;
}

.news-right {
  display: flex;
  flex-direction: column;
  flex: 0 1 80%;
  width: 80%;
  align-self: flex-start;
  margin-top: 8px;
  box-sizing: border-box;
  padding: 0 10px;
  height: 100%;
}

.news-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-right .title {
  width: 100%;
  flex: 0 0 28%;
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 5px;
}

.news-right .abstract {
  flex: 0 0 41%;
  font-size: 12px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 16px;
}

.music {
  /* 音频样式 */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
}

.music p {
  font-size: 12px;
  line-height: 15px;
  width: 100%;
  overflow: hidden;
  margin-bottom: 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;
}

.music div {
  width: 100%;
}

.music audio {
  height: 45px;
  width: 250px;
}

/*.mint-ui*/
.mint-button--small {
  padding: 0 3px;
}

/*关闭按钮*/
.close-btn {
  position: absolute;
  z-index: 99999;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background: red;
}

.mint-button--small {
  line-height: 33px;
}

.accurateParent {
  position: relative;
  margin-bottom: 15px;
  user-select: none;
}

.omit-the-hidden {
  /* 省略展示额外内容 */
  position: relative;
  max-height: 160px;
  margin-bottom: 15px;
  overflow: hidden;
}

.omit-the-hidden .mask {
  /* 蒙层遮罩*/
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 20px;
  opacity: 0.6;
  background: #fff;
  background-image: linear-gradient(
    -180deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 70%
  );
}

.show-more {
  /* 展示更多按钮 */
  position: absolute;
  width: 45px;
  /* left: 0; */
  right: 0;
  margin: auto;
  width: 100%;
  text-align: center;
  color: #fff;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;
  background: rgba(244, 68, 68, 0.4);
  /* background: #26a2ff; */
  border: 1px dashed rgba(165, 85, 85, 0.4);
  z-index: 3;
  bottom: -2px;
}

.show-more:active {
  background-color: rgba(211, 51, 51, 0.9);
}

/*loading 动画*/
.loading span {
  margin-top: 15px;
  font-size: 14px;
  font-weight: 200;
  font-family: Verdana, Geneva, Arial, sans-serif;
}

.loading span b {
  content: "";
  margin-right: 3px;
  display: inline-block;
  width: 3px;
  height: 3px;
  background: #000;
  border-radius: 50%;
}

.loading span b:nth-child(1) {
  animation: beating 0.8s ease infinite alternate;
}

.loading span b:nth-child(2) {
  animation: beating 0.8s ease infinite alternate 0.3s;
}

.loading span b:nth-child(3) {
  animation: beating 0.8s ease infinite alternate 0.4s;
}

@keyframes beating {
  from {
    transform: translateY(0px) scale(0.8);
  }

  to {
    transform: translateY(-6px) scale(1.2);
  }
}

.goMediaBtn {
  width: 100%;
  margin: 20px 0 10px;
  padding: 0 15px;
  border-radius: 20px;
}
.mediaDiv {
  margin-top: 10px;
  padding-top: 10px;
  box-shadow: darkgray 0 -7px 8px -1px;
}
.mediaDiv div {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-around;
}
.mediaDiv img {
  height: 60px;
  width: 40px;
}
.cancleShowMedia img {
  height: 25px;
  width: auto;
}

.other-box {
  .other-quesiton {
    margin-top: 20px;
    .other-title {
      // color: #333;
    }
    .other-content {
      color: #145dff;
      cursor: pointer;
    }
  }
}
.no-data {
  text-align: center;
}
.stop-request {
  position: fixed;
  bottom: 85px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  left: 50%;
  transform: translatex(-50%);
  border: 1px solid #145dff;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
  z-index: 9999;
  
  @media screen and (max-width: 900px) {
    bottom: 80px;
    padding: 8px 12px;
    font-size: 14px;
  }
  
  .stop-icon {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    background: #145dff;
    margin-right: 10px;
    
    @media screen and (max-width: 900px) {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }
}
.page-info {
  padding: 20px;
  font-size: 18px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.start-box {
  .start-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
    
    @media screen and (max-width: 900px) {
      font-size: 18px;
      margin-bottom: 15px;
    }
  }
  .start-list {
    display: flex;
    // align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    
    @media screen and (max-width: 900px) {
      flex-direction: column;
    }
    
    .start-item {
      display: flex;
      align-items: center;
      width: 49%;
      background: #f6f8fc;
      padding: 10px;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      
      @media screen and (max-width: 900px) {
        width: 100%;
        margin-bottom: 10px;
      }
      
      .start-item-title {
        font-size: 16px;
        // font-weight: 700;
        margin-bottom: 10px;
        
        @media screen and (max-width: 900px) {
          font-size: 14px;
          margin-bottom: 8px;
        }
      }
      img {
        margin-right: 10px;
        width: 26px;
        // filter: drop-shadow(4px 4px 2px #409eff);
        
        @media screen and (max-width: 900px) {
          width: 22px;
          margin-right: 8px;
        }
      }
      .start-item-content {
        color: #666;
        
        @media screen and (max-width: 900px) {
          font-size: 13px;
        }
      }
    }
    .start-item:nth-child(1),
    .start-item:nth-child(2) {
      margin-bottom: 10px;
    }
  }
}

.start-box1 {
  text-align: center;
}
.chat-ass-mobile {
  display: none;
  padding: 0 16px 0 74px;
  font-size: 14px;
  color: #666;
  .chat-ass-title {
    color: #444;
    font-size: 14px;
    margin-bottom: 6px;
  }
  .ass-item {
    margin-bottom: 10px;
    div {
      padding: 8px 10px;
      background: #fff;
      border-radius: 6px;
      display: inline-block;
      cursor: pointer;
    }
  }
  .change-ass {
    cursor: pointer;
    color: #1b4aef;
  }
}
.chat-ass {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 22px;
  font-size: 14px;
  color: #333;
  & > div:first-child {
    flex-shrink: 0;
    margin-right: 10px;
  }
  // .ass-list {
  //   display: flex;
  //   flex: 1;
  //   overflow: hidden;

  .ass-item {
    padding: 6px 10px;
    background: #fff;
    margin-right: 8px;
    overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // width: 20%;
    // min-width: 100px;
    // max-width: 200px;
    border-radius: 6px;
    cursor: pointer;
    margin: 8px 4px 0 0;
  }

  // }
  .change-ass {
    flex-shrink: 0;
    color: #1b4aef;
    cursor: pointer;
    margin-top: 8px;
  }
}
@media screen and (max-width: 900px) {
  .chat-ass {
    display: none;
  }
  .chat-ass-mobile {
    display: block;
    padding: 0 10px 0 50px;
    margin-bottom: 10px;
    
    .chat-ass-title {
      font-size: 13px;
      margin-bottom: 8px;
    }
    
    .ass-item {
      margin-bottom: 8px;
      
      div {
        padding: 6px 10px;
        font-size: 13px;
      }
    }
    
    .change-ass {
      font-size: 13px;
      margin-top: 8px;
    }
  }
  
  .chat-list {
    padding-bottom: 120px; /* 为底部输入框和推荐问题留出空间 */
  }
}
</style>
<style lang="scss">
.chat-message .send-content .el-select {
  width: 78px;
}
.chat-message .send-content .el-select .el-input__inner {
  border: none;
  padding: 0;
  font-size: 12px;
}
.table-loading .el-loading-spinner {
  top: 15%;
}
.ai-table td {
  padding-right: 20px;
}
.video-dialog {
  min-width: 340px;
  width: 95%;
}
.video-dialog .video-js {
  max-width: 100%;
}

.el-popover {
  min-width: 0;
}
.select-box .el-popover__reference-wrapper {
  display: flex;
  align-items: center;
}
.select-list ul li {
  line-height: 28px;
  a {
    color: #333;
    text-decoration: underline;
  }
  text-align: center;
}

.questionnaire {
  .naire-title {
    margin-bottom: 30px;
  }
  .el-form-item {
    margin-bottom: 8px;
    .el-form-item__label {
      text-align: left;
    }
    .el-input__inner {
      height: 30px;
      line-height: 30px;
    }
    .el-radio {
      margin-bottom: 8px;
      margin-right: 0;
      .el-radio__label {
        white-space: pre-wrap;
        margin-right: 20px;
      }
    }
  }
}
.el-scrollbar .el-scrollbar__bar {
  opacity: 1 !important;
}
.feedback-list {
  .el-checkbox-button {
    .el-checkbox-button__inner {
      border: none;
      margin: 0 10px 10px 0 !important;
      border-radius: 6px;
      border-left: none !important;
      background: #ddd;
      color: #333;
      box-shadow: none;
    }
  }
  .is-checked {
    .el-checkbox-button__inner {
      background: #589ef8;
      color: #fff;
    }
  }
}

.pdf-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 998;
  
  @media screen and (max-width: 900px) {
    top: 60px;
    right: 10px;
    
    .el-upload-dragger {
      padding: 8px 12px;
      font-size: 12px;
    }
  }
  
  .el-upload-dragger {
    width: auto;
    height: auto;
    padding: 10px 20px;
    background: #1b4aef;
    border: none;
    .el-upload__text {
      color: #fff;
    }
  }
  .el-upload-list {
    display: none;
  }
}
.pdf-view {
  max-width: 100vw;
  .el-message-box {
  }
  .el-message-box__message {
    max-height: 70vh;
    overflow: hidden;
  }
}

// 美化聊天内容的样式
.chat-bubble {
  blockquote {
    margin: 10px 0;
    padding: 8px 12px;
    background: #f5f7fa;
    border-left: 4px solid #1b4aef;
    border-radius: 4px;
    font-style: italic;
    color: #666;
  }
  
  strong {
    font-weight: 600;
    color: #333;
  }
  
  // 处理换行和段落间距
  br + br {
    line-height: 1.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/official/chatdev.vue